export const unformattedVehicleValue: number = 180000;
export const unformattedCompensationValue: number = 110000;
export const month: number = 40;
export const inflationBonus: number = .2;
